import { ApiClient } from '@webapp/core/services/ApiClient'
import { SettingsRepository } from './SettingsRepository'

export const settingsRepository = new SettingsRepository({
  httpClient: ApiClient,
})
